/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Erweiterte Filter schließen`
};

const en_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Close advanced filters`
};

const es_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar filtros avanzados`
};

const fr_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Fermer les filtres avancés`
};

const it_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Chiudi i filtri avanzati`
};

const nl_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `De geavanceerde filters sluiten`
};

const pt_poi_filters__back = /** @type {(inputs: {}) => string} */ () => {
	return `Fechar os filtros avançados`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__back(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__back", locale)
	if (locale === "de") return de_poi_filters__back(inputs)
	if (locale === "en") return en_poi_filters__back(inputs)
	if (locale === "es") return es_poi_filters__back(inputs)
	if (locale === "fr") return fr_poi_filters__back(inputs)
	if (locale === "it") return it_poi_filters__back(inputs)
	if (locale === "nl") return nl_poi_filters__back(inputs)
	return pt_poi_filters__back(inputs)
};